import React, {useState} from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { NavLink, useLocation } from 'react-router-dom';
import {appStings} from '..';

import logo from '../assets/layout/Gefuehlsmonster_Logo-Monster_schwarz-weiss.svg';

export const Header = ({games, currentGame, onChangeGame, onReset}) => {
    const { pathname } = useLocation();
    const { locale, messages } = useIntl();
    const [submenuVisible, toggleSubmenu] = useState(true);
    const [faqVisible, toggleFaq] = useState(false);
    const currentGameData = games.items.filter((item) => item.id === currentGame)[0];
    const submenuClass = "submenu game-menu collapse";
    const faqClass = "faq-area collapse";

    const getMatchingLangRoute = (language) => {
        const [, route] = pathname.split(locale);
        const routeKey = Object.keys(messages).find(key => messages[key] === route);
        const matchingRoute = appStings[language][routeKey];
        return `/${language}` + matchingRoute;
    };
    const faqLinkTextId = currentGameData.faq + '.linkText';
    const faqLinkUrlId = currentGameData.faq + '.linkUrl';

    return (
        <header id="header" className="sticky-top">
            <div className="container-fluid">
                <nav className="navbar navbar-expand navbar-dark bg-primary">
                    <a className="navbar-brand" href="/">
                        <img src={logo} alt={<FormattedMessage id="company" />}/>
                    </a>

                    <div className="navbar-text title">
                        <FormattedMessage id="header.title"/><br/>
                        <span className="game-title">
                            <FormattedMessage id={currentGameData.name} />
                            </span>
                    </div>

                    <div className="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">

                        <ul className="navbar-nav">
                            <li className="nav-item active">
                                <button className="nav-link btn-faq" onClick={() => toggleFaq(!faqVisible)} id="faqBtn">
                                    <span className="sr-only"><FormattedMessage id="header.btn.faq" /></span>
                                </button>
                            </li>
                            <li className="nav-item">
                                <button className="nav-link btn-first main-btn" onClick={onReset}>
                                    <FormattedMessage id="header.btn.resetGame" />
                                </button>
                            </li>
                            <li className="nav-item dropdown">
                                <button
                                    className="nav-link btn-last main-btn dropdown-toggle"
                                    onClick={() => toggleSubmenu(!submenuVisible)}
                                    id="navbarDropdown"
                                    data-toggle="collapse"
                                    aria-haspopup="true">
                                    <FormattedMessage id="header.btn.gameSelection" />
                                </button>
                            </li>
                        </ul>
                        <ul id="lang-nav" className="navbar-nav">
                            <li className={locale === 'de' ? "nav-item active" : "nav-item"}>
                                <NavLink
                                    className="nav-link"
                                    activeClassName="nav-link active"
                                    to={getMatchingLangRoute('de')}
                                >
                                    {'Deutsch'}
                                </NavLink>
                            </li>
                            <li className={locale === 'en' ? "nav-item active" : "nav-item"}>
                                <NavLink
                                    className="nav-link"
                                    activeClassName="nav-link active"
                                    to={getMatchingLangRoute('en')}
                                >
                                    {'English'}
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                </nav>
                <div className={submenuVisible ? submenuClass + " show" : submenuClass} aria-labelledby="navbarDropdown">
                    <div className="innerContent">
                        <ul className="nav nav-fill" aria-labelledby="navbarDropdown">
                            {games.items.map((game, index) => (
                                <li className={"nav-item" + (game.id === currentGame ? " current" : "")} key={index}>
                                    <button
                                        className="sub-nav-link"
                                        onClick={() => {
                                            toggleSubmenu(!submenuVisible);
                                            onChangeGame(game.id);
                                        }}
                                    >
                                        <FormattedMessage id={game.name} />
                                        {game.badge &&
                                            <span className="badge badge-info"><FormattedMessage id={game.badge} /></span>
                                        }
                                    </button>
                                    <p><FormattedMessage id={game.description} values={{br: <br/>}} /></p>
                                </li>
                            ))}
                        </ul>
                        <p className="text-right"><FormattedMessage id="footer.serviceCopyLine" />{' '}
                            <a href="https://www.gefuehlsmonster.de/" target="_blank" rel="noopener noreferrer">
                                <FormattedMessage id="company" />
                            </a>
                        </p>
                        <button type="button" className="btn-close icon-close" aria-label="Close" onClick={() => toggleSubmenu(!submenuVisible)} />
                    </div>
                </div>
                <div className={faqVisible ? faqClass + " show" : faqClass} aria-labelledby="faqBtn">
                    <div className="innerContent">
                        <button type="button" className="btn-close icon-close" aria-label="Close" onClick={() => toggleFaq(!faqVisible)} />
                        <h3>
                            <FormattedMessage id="header.faq.title"
                                values={{
                                    spielName: <FormattedMessage id={currentGameData.name} />,
                                }}
                            />
                        </h3>
                        <p className="faq-description">
                            <FormattedMessage
                                id={currentGameData.faq}
                                values={{
                                    br: <br/>,
                                    link: (messages[faqLinkUrlId] && messages[faqLinkTextId] ?
                                        <a href={messages[faqLinkUrlId]} rel="noopener noreferrer" target="_blank"><FormattedMessage id={faqLinkTextId} /></a> : '')
                                }}
                            />
                        </p>
                    </div>
                </div>
            </div>
        </header>
    );
};